import React from 'react';
import Hero from '../../components/pages/Insights/Hero/Hero';
import Pillars from '../../components/pages/Insights/Pillars/Pillars';
import Featured from '../../components/pages/Insights/Featured/Featured';
import News from '../../components/pages/Insights/News/News';
import EconomicCalendar from '../../components/pages/Insights/EconomicCalendar/EconomicCalendar';
import Subscribe from '../../components/pages/Insights/Subscribe/Subscribe';
import Heritage from '../../components/pages/Insights/Heritage/Heritage';

const Insights = () => {
  return (
    <div>
      <Hero />
      <Pillars />
      <Featured />
      <News />
      <EconomicCalendar />
      <Subscribe />
      <Heritage />
    </div>
  );
};

export default Insights;
